// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_AXTjQ","infoIcon":"infoIcon__1Vdm","bottomSubmit":"bottomSubmit_zwhmx"};